<template>
<div style="overflow: auto;">
<el-menu
    @select="select"
    unique-opened
    :collapse="iscollapse"
    :default-active="path"
    :collapse-transition="false"
    class="el-menu-vertical-demo"
    router>
    <el-menu-item index="/company/index">
        <i class="el-icon-s-home"></i>
        <span>基础信息</span>
    </el-menu-item>
    <!-- <el-menu-item index="/staff/index">
        <i class="el-icon-user-solid"></i>
        <span>人员机构</span>
    </el-menu-item> -->
    <el-menu-item index="/unit/index" v-if="this.$store.state.controlId != 618">
        <i class="el-icon-odometer"></i>
        <span>风险单元</span>
    </el-menu-item>
    <!-- <el-menu-item index="/building/index">
        <i class="el-icon-office-building"></i>
        <span>场所管理</span>
    </el-menu-item> -->
    <!-- <el-menu-item index="/device/index">
        <i class="el-icon-set-up"></i>
        <span>设备管理</span>
    </el-menu-item> -->
    <!-- <el-menu-item index="/work/index">
        <i class="el-icon-files"></i>
        <span>作业管理</span>
    </el-menu-item> -->
    <!-- <el-menu-item v-if="$store.getters.needControlCompliance" index="/controlCompliance/index">
        <i class="el-icon-connection"></i>
        <span>隐患排查治理情况</span>
    </el-menu-item> -->
  </el-menu>
  <!-- <el-button @click="click" type="primary">an</el-button> -->
</div>

</template>

<script>
  import {principleMap} from '../../../router/control'
  export default {
    props: {
      iscollapse: Boolean
    },
    data () {
      return {
        userInfo: {},
        permissionMap: {},
        url: false
      }
    },
    computed: {
      divisionPrinciple () {
        if (this.$store.state.controlId) {
          let key = this.$store.state.controlId
          return principleMap[key]
        }
      },
      path () {
        if (this.url) {
          this.url = false
          return '/company/companyinfo'
        }
        return this.$route.path
      },
      query () {
        return this.permissionMap['QueryVisited'] && this.permissionMap['NoQueryVisited'] && this.permissionMap['QuestionableRecords'] && this.permissionMap['RevenueAlert']
      },
      riskLevel () {
        let controlId = this.$store.state.controlId
        if (controlId === 101 || controlId === 102 || controlId === 103) {
          return '/company/companyinfo'
        } else {
          return '/company/industry'
        }
      }
    },
    mounted () {
      let userInfo = this.$store.getters.userInfo
      this.userInfo = userInfo
       // 权限表
      let permissionMap = {}
      let permissionList = JSON.parse(this.$store.state.permissionList)
      for (let i in permissionList) {
        permissionMap[permissionList[i]] = true
      }
      this.permissionMap = permissionMap
    },
    methods: {
      select (index, indexPath) {
        if (this.$route.path === '/company/companyinfo') {
          this.url = true
        }
      },
      click () {
      }
    }
  }
</script>

<style scoped>
  .el-scrollbar__wrap {
  overflow-x: hidden;
}
.item-left {
  padding-left:5px !important;
}
.item-left2 {
  padding-left:20px !important;
}
.el-submenu__title {
  padding: 0 !important;
}
.el-menu-item {
  /* padding: 0 !important; */
}
</style>



// WEBPACK FOOTER //
// src/components/frame/company/Sidebar.vue